import { writable } from "svelte/store";

export const assessmentResponses = writable("assessmentResposnse");
assessmentResponses.set({});

export const carouselPosition = writable("carouselPosition");
carouselPosition.set({});
